import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "variant", "align", "color", "truncate", "maxLines", "strikethrough", "children"],
  _excluded2 = ["variant", "align"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.reduce.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { Core } from "@faire/design-tokens";
import { isResponsiveProp } from "@faire/web--source/slate/Theme/ResponsiveProp";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import cn from "classnames";
import React from "react";
import Color from "../Color";
// eslint-disable-next-line import/no-unassigned-import
import "./native-styles.css";
import { FONT_RAMP, variantTagMap } from "./utils";
var resolveColor = function resolveColor(color) {
  if (color && color in Color) {
    // @ts-expect-error this is a hack
    return Color[color];
  }
  if (!color) {
    return Core.text.default;
  }
  return color;
};
var BaseTypography = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "paragraphSansRegular" : _ref$variant,
    align = _ref.align,
    color = _ref.color,
    truncate = _ref.truncate,
    maxLines = _ref.maxLines,
    strikethrough = _ref.strikethrough,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var vars = {};
  var classNames = [];
  // Alignment
  if (isResponsiveProp(align)) {
    vars["--f_t_text_align_mobile"] = align.mobileAndAbove;
    vars["--f_t_text_align_tablet"] = align.tabletAndAbove != null ? align.tabletAndAbove : vars["--f_t_text_align_mobile"];
    vars["--f_t_text_align_desktop"] = align.desktopAndAbove != null ? align.desktopAndAbove : vars["--f_t_text_align_tablet"];
    vars["--f_t_text_align_xlarge"] = align.xLargeAndAbove != null ? align.xLargeAndAbove : vars["--f_t_text_align_desktop"];
    vars["--f_t_text_align_xxlarge"] = align.xxLargeDesktop != null ? align.xxLargeDesktop : vars["--f_t_text_align_xlarge"];
    classNames.push("f_t_variable_text_align");
  } else if (align != null) {
    vars["--f_t_text_align_mobile"] = align;
    classNames.push("f_t_single_value_text_align");
  }
  // Variant
  classNames.push("f_t_".concat(variant));
  var variantTag = getVariantTag(variant);
  var tag = as || variantTag || "p";
  color = resolveColor(color);
  var className = cn("f_t_base", truncate && "f_t_truncate", maxLines && "f_t_maxLines", strikethrough && "f_t_strikethrough", color === "inherit" ? "f_t_inheritColor" : "f_t_color", rest.className, classNames);
  var rampLineHeight = FONT_RAMP[variant]["line-height"];
  var style = _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, vars), {}, {
    "--f_t_color": color === "inherit" ? undefined : color,
    "--f_t_maxLines": maxLines ? String(maxLines) : "",
    "--f_t_maxHeight": rampLineHeight && maxLines ? "calc(".concat(maxLines, " * ").concat(rampLineHeight, ")") : undefined,
    /* 50% opacity - cannot use Opacity.0_50 constant as it is client side only */
    "--f_t_decorationColor": color === "inherit" ? undefined : color + "80"
  })), rest.style);
  return /*#__PURE__*/React.createElement(tag, _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    className: className,
    ref: ref
  }), children);
});
export var Typography = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? "paragraphSansRegular" : _ref2$variant,
    align = _ref2.align,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  if (isResponsiveProp(variant)) {
    // Reduce the incoming props to the smallest number possible of ResponsiveContentV2 props
    var responsiveProps = ["mobileAndAbove", "tabletAndAbove", "desktopAndAbove", "xLargeAndAbove", "xxLargeDesktop"];
    var responsiveContentOnlyProps = ["mobile", "tablet", "desktop", "xlarge", "xxlarge"];
    var responsiveContentOrAboveProps = [null, "tabletAndAbove", "desktopAndAbove", "xLargeAndAbove", "xxlarge"];
    var props = {};
    var highestIdx = Object.keys(variant).map(function (key) {
      return responsiveProps.indexOf(key);
    }).reduce(function (a, b) {
      return Math.max(a, b);
    });
    for (var _i = 0, _Object$entries = Object.entries(variant); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        subvariant = _Object$entries$_i[1];
      var idx = responsiveProps.indexOf(key);
      var subtypography = /*#__PURE__*/React.createElement(BaseTypography, _objectSpread(_objectSpread({
        variant: subvariant,
        align: align
      }, rest), {}, {
        ref: ref
      }));
      if (idx < highestIdx) {
        props[responsiveContentOnlyProps[idx]] = subtypography;
        for (var j = idx + 1; !Object.keys(variant).includes((_responsiveProps$j = responsiveProps[j]) !== null && _responsiveProps$j !== void 0 ? _responsiveProps$j : "") && j < responsiveProps.length; j++) {
          var _responsiveProps$j;
          props[responsiveContentOnlyProps[j]] = subtypography;
        }
      } else {
        props[responsiveContentOrAboveProps[idx]] = subtypography;
      }
    }
    return /*#__PURE__*/React.createElement(ResponsiveContentV2, _objectSpread(_objectSpread({}, props), {}, {
      flat: true
    }));
  } else {
    return /*#__PURE__*/React.createElement(BaseTypography, _objectSpread(_objectSpread({
      variant: variant,
      align: align
    }, rest), {}, {
      ref: ref
    }));
  }
});
var getVariantTag = function getVariantTag(variant) {
  return isResponsiveProp(variant) ? variantTagMap[variant.mobileAndAbove] : variantTagMap[variant];
};
export var Span = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Typography, _objectSpread(_objectSpread({
    as: "span"
  }, props), {}, {
    ref: ref
  }));
});